module.exports = __webpack_public_path__ + "img/diamond.7a1d9e2e.png";